// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ArrowUp } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconArrowUp(props: any) {
    return <IconBase icon={ArrowUp} {...props} />
  }

  export default IconArrowUp
  